'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Logo = require('../../../../atoms/logo/jsx/Logo');

var _Logo2 = _interopRequireDefault(_Logo);

var _Button = require('../../../../atoms/button/jsx/Button');

var _Button2 = _interopRequireDefault(_Button);

var _MPPMainMenu = require('./MPPMainMenu');

var _MPPMainMenu2 = _interopRequireDefault(_MPPMainMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MPPHeaderRoot = function (_Component) {
  _inherits(MPPHeaderRoot, _Component);

  function MPPHeaderRoot(props) {
    _classCallCheck(this, MPPHeaderRoot);

    var _this = _possibleConstructorReturn(this, (MPPHeaderRoot.__proto__ || Object.getPrototypeOf(MPPHeaderRoot)).call(this, props));

    _this.generateClassNames = function () {
      return (0, _classnames2.default)('pp-header', {
        'pp-header--submenu-close': _this.props.isClosing,
        'pp-header--submenu-open': _this.props.activeLink,
        'pp-header--menu-open': _this.props.menuOpen,
        'pp-header--rtl': _this.props.rtl
      }, _this.props.className);
    };

    _this.renderLogo = function (logoProps) {
      return _react2.default.createElement(
        'div',
        { className: 'pypl-logo-wrapper' },
        _react2.default.createElement(_Logo2.default, {
          text: logoProps.text,
          href: logoProps.href,
          color: logoProps.color || 'white',
          'data-pa-click': 'Header-Logo-PayPal Logo'
        })
      );
    };

    _this.renderMainMenu = _this.renderMainMenu.bind(_this);
    _this.renderMenuButton = _this.renderMenuButton.bind(_this);
    return _this;
  }

  _createClass(MPPHeaderRoot, [{
    key: 'renderMenuButton',
    value: function renderMenuButton(labelMenuButton) {
      if (this.props.config.useMinimalHeader || !this.props.content.mainMenuContent) {
        var logoutBtn = this.props.content.minimalHeader.headerButtons.filter(function (el) {
          return el.id === 'logout-button';
        })[0];
        if (logoutBtn) {
          return _react2.default.createElement(
            'div',
            { className: 'menu-button-wrapper' },
            _react2.default.createElement(
              _Button2.default,
              {
                id: logoutBtn.id,
                href: logoutBtn.href,
                className: 'logout-button-mobile',
                size: 'small',
                color: logoutBtn.color || 'outline-white',
                fpti: 'HeaderMainMenu-Cta-' + logoutBtn.text
              },
              logoutBtn.text
            )
          );
        }
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'menu-button-wrapper' },
        _react2.default.createElement(
          _Button2.default,
          {
            id: 'menu-button',
            className: 'menu-button',
            size: 'small',
            color: 'outline-white',
            onClick: this.props.handlers.handleMenuButton,
            fpti: 'MainMenu-Cta-' + labelMenuButton
          },
          labelMenuButton
        )
      );
    }
  }, {
    key: 'renderMainMenu',
    value: function renderMainMenu() {
      if (this.props.config.useMinimalHeader || !this.props.content.mainMenuContent) {
        return null;
      }
      return _react2.default.createElement(_MPPMainMenu2.default, {
        content: this.props.content,
        activeLinkIndex: this.props.activeLinkIndex,
        closingLinkIndex: this.props.closingLinkIndex,
        handlers: this.props.handlers,
        register: this.props.register
      });
    }
  }, {
    key: 'renderHeaderButtons',
    value: function renderHeaderButtons() {
      // Double check for backwards compatibility
      if (this.props.config.hideHeaderButtons !== undefined && this.props.config.hideHeaderButtons) {
        return null;
      }

      var headerButtons = this.props.content.minimalHeader.headerButtons;


      if (headerButtons) {
        return _react2.default.createElement(
          'div',
          { id: 'header-buttons', className: 'header-buttons' },
          _react2.default.createElement(
            'div',
            null,
            headerButtons.map(function (elem, idx) {
              var elemKey = '' + elem.href + idx;
              return _react2.default.createElement(
                _Button2.default,
                {
                  id: elem.id,
                  key: elemKey,
                  href: elem.href,
                  size: 'small',
                  color: elem.color || 'outline-white',
                  fpti: 'HeaderMainMenu' + idx + '-Cta-' + elem.text
                },
                elem.text
              );
            })
          )
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$content$minima = this.props.content.minimalHeader,
          labelMenuButton = _props$content$minima.labelMenuButton,
          logo = _props$content$minima.logo;


      return _react2.default.createElement(
        'header',
        {
          ref: function ref(_ref) {
            return _this2.props.getHeaderRef(_ref);
          },
          className: this.generateClassNames(),
          'data-building-block': 'organism',
          style: this.props.style
        },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'pp-header__wrapper container' },
            this.renderMenuButton(labelMenuButton),
            this.renderLogo(logo),
            this.renderMainMenu(),
            this.renderHeaderButtons()
          )
        )
      );
    }
  }]);

  return MPPHeaderRoot;
}(_react.Component);

MPPHeaderRoot.propTypes = {
  config: _propTypes2.default.object.isRequired,
  content: _propTypes2.default.object.isRequired,
  className: _propTypes2.default.string,
  rtl: _propTypes2.default.bool,
  isClosing: _propTypes2.default.bool.isRequired,
  menuOpen: _propTypes2.default.bool.isRequired,
  activeLink: _propTypes2.default.object,
  activeLinkIndex: _propTypes2.default.number.isRequired,
  closingLinkIndex: _propTypes2.default.number,
  handlers: _propTypes2.default.object.isRequired,
  register: _propTypes2.default.func.isRequired,
  getHeaderRef: _propTypes2.default.func.isRequired,
  style: _propTypes2.default.object
};

MPPHeaderRoot.defaultProps = {
  className: '',
  activeLink: null,
  closingLinkIndex: -1,
  rtl: false,
  style: {}
};

exports.default = MPPHeaderRoot;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/header/jsx/components/MPPHeaderRoot.js
// module id = 500
// module chunks = 4